import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {MeasureModel} from '@/libs/Api';
import {MeasuresDataService} from '@/libs/measures/measures-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const measuresStore = registerCrudStore<MeasureModel, MeasureModel>(BusinessModule.Measure, new MeasuresDataService());
